import _join from "ramda/es/join";
import _replace from "ramda/es/replace";
import _juxt from "ramda/es/juxt";
import _pipe from "ramda/es/pipe";
import _curry from "ramda/es/curry";

var operationOnUnit = _curry(function (f, unitString) {
  return _pipe(_juxt([_pipe(parseFloat, f), _replace(/\d|\./g, '')]), _join(''))(unitString);
});

export default operationOnUnit;